module.exports = __webpack_public_path__ + "FixelDisplay-BlackItalic-30fa62887075f73a55a844e609f9a168.woff2";